<template>
  <div class="wrapp-form">
    <b-form-group id="grouptaxid" :label-for="`${name}-taxid`">
      <base-input
        :name="`${name}-taxid`"
        autocomplete="taxid"
        v-validate="'required'"
        v-model="value.fiscalcode"
        type="text"
        :placeholder="`${$t('invoice.fiscalcode')}`"
        :validations="[
          {
            condition: errors.has(`${name}-taxid`),
            text: errors.first(`${name}-taxid`)
          }
        ]"
        @input="updateField"
      >
      </base-input>
    </b-form-group>
    <b-form-group id="grouppec" :label-for="`${name}-pec`">
      <base-input
        :id="`${name}-pec`"
        :name="`${name}-pec`"
        v-validate="'email'"
        v-model="value.pec"
        type="text"
        :placeholder="`${$t('invoice.pec')}`"
        :validations="[
          {
            condition: errors.has(`${name}-pec`),
            text: errors.first(`${name}-pec`)
          }
        ]"
        @input="updateField"
      >
      </base-input>
    </b-form-group>
  </div>
</template>

<script>
import BaseInput from 'theme/components/Form/BaseInput'

export default {
  name: 'Private',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {}
    },
    name: {
      type: String
    }
  },
  inject: ['$validator'],
  $_veeValidate: {
    value () {
      return this.value
    },
    name () {
      return this.name
    }
  },
  methods: {
    updateField (e) {
      const _this = this
      this.$nextTick(() => {
        return _this.$emit('input', _this.value)
      })
    }
  },
  components: {
    BaseInput
  }
}
</script>
